/** @jsx jsx */
import { jsx, Grid } from "theme-ui";

const GridContainer = ({ columns, gap, className, children }) => {
  return <Grid 
    columns={columns ?? [1, 2, 3]}
    gap={gap ?? [3, 6, 7]}
    className={className}
    sx={{
      width: "100%",
      maxWidth: "container",
      mx: "auto",
    }}
  >
    {children}
  </Grid>;
};

export default GridContainer;